import api from './api';

export const chatbotAPI = {
  // Get chat history for a thread
  getChatHistory: (threadId) => api.get(`/api/chatbot/history/${threadId}`),

  // Get all evaluations for a thread
  getEvaluations: (threadId) => api.get(`/api/chatbot/evaluations/${threadId}`),

  // Save a new evaluation
  saveEvaluation: (data) => api.post('/api/chatbot/evaluate', data),

  // Update an existing evaluation
  updateEvaluation: (id, data) => api.put(`/api/chatbot/evaluate/${id}`, data),

  // Get list of threads with human feedback
  getFeedbackList: (params = {}) => api.get('/api/chatbot/feedback-list', { params }),
};

export default chatbotAPI;
